namespace gotoAndPlay {

    export class GlobalBanner {

        element: JQuery;

        closeButton: JQuery;
        expireTimeInDays: number;

        constructor(target: HTMLElement) {
            this.element = $(target);

            this.closeButton = this.element.find('.global-banner__close');

            this.expireTimeInDays = this.element.data('cookie');

            this.init();
        }

        init(): void {
            if (Cookie.get('bannerClosed') == '1') {
                this.element.remove();
            } else {
                this.element.addClass('is-visible');
                this.closeButton.on('click', this.closeBanner.bind(this));
            }
        }

        closeBanner(): void {
            Cookie.set('bannerClosed', '1', this.expireTimeInDays * 24);
            this.element.remove();
        }
    }

    $((): void => {
        const globalBanners = $('.global-banner');
        if (globalBanners.length > 0) {
            const globalBanner = new GlobalBanner(globalBanners.get()[0]);
        }
    });
}
